module.exports = __webpack_public_path__ + "img/placeholder-png-image.952ebdf4.png";